import React, { useState, useRef, useEffect } from "react";
import { Modal, Button, Alert, Table, Badge } from "react-bootstrap";
import {
  FaDownload,
  FaFileExcel,
  FaTable,
  FaCheck,
  FaCloudUploadAlt,
} from "react-icons/fa";
import { FormCheck } from "react-bootstrap";
import Papa from "papaparse";
import * as XLSX from "xlsx";
import "../../components/Components/import-modal-styles.css";
import { UserImport } from "../../api/Webservices";
import { PiMicrosoftExcelLogoFill } from "react-icons/pi";
import { FaWindowClose } from "react-icons/fa";
import ExcelJS from 'exceljs';
const ImportModal = ({ show, onHide, onImportComplete }) => {
  const [step, setStep] = useState("upload");
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState("");
  const [previewData, setPreviewData] = useState([]);
  const [headers, setHeaders] = useState([]);
  const [selectedRow, setSelectedRow] = useState(0);
  const [error, setError] = useState("");
  const [isDragging, setIsDragging] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const fileInputRef = useRef(null);

  // Required fields for the API
  const requiredFields = [
    "first_name",
    "last_name",
    "email",
    "ticket_name",
    'payment_method',
  
  ];

  useEffect(() => {
    if (show) {
      resetState();
    }
  }, [show]);

  const resetState = () => {
    setStep("upload");
    setFile(null);
    setFileName("");
    setPreviewData([]);
    setHeaders([]);
    setSelectedRow(0);
    setError("");
    setIsDragging(false);
    setIsLoading(false);
  };

  const handleClose = () => {
    resetState();
    onHide();
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      processFile(selectedFile);
    }
  };

  const processFile = (selectedFile) => {
    const fileExt = selectedFile.name.split(".").pop().toLowerCase();
    if (["csv", "xlsx", "xls"].includes(fileExt)) {
      setFile(selectedFile);
      setFileName(selectedFile.name);
      setError("");
      setIsLoading(true);

      const reader = new FileReader();

      reader.onload = (e) => {
        try {
          const data = e.target.result;
          let parsedData = [];
          let parsedHeaders = [];

          if (fileExt === "csv") {
            const result = Papa.parse(data, {
              header: false,
              skipEmptyLines: true,
            });
            parsedData = result.data;
          } else {
            const workbook = XLSX.read(data, { type: "binary" });
            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];
            parsedData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
          }

          if (parsedData.length === 0) {
            setError("The file is empty or contains no valid data");
            setIsLoading(false);
            return;
          }

          // Assume first row is headers
          parsedHeaders = parsedData[0];
          const dataRows = parsedData.slice(1);

          // Validate required fields
          // const missingFields = requiredFields.filter(
          //   (field) =>
          //     !parsedHeaders.some(
          //       (header) => header.toLowerCase().trim() === field.toLowerCase(),
          //     ),
          // );

          // if (missingFields.length > 0) {
          //   setError(
          //     `Missing required columns: ${missingFields.join(", ")}. Please ensure your file has: ${requiredFields.join(", ")}`,
          //   );
          //   setIsLoading(false);
          //   return;
          // }

          setHeaders(parsedHeaders);
          setPreviewData(dataRows);
          setIsLoading(false);
          setStep("mapping");
        } catch (err) {
          console.error("Error parsing file:", err);
          setError("Error parsing file. Please check the file format.");
          setIsLoading(false);
        }
      };

      reader.onerror = () => {
        setError("Error reading file");
        setIsLoading(false);
      };

      if (fileExt === "csv") {
        reader.readAsText(selectedFile);
      } else {
        reader.readAsBinaryString(selectedFile);
      }
    } else {
      setError("Please upload a CSV, XLSX, or XLS file");
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    const droppedFile = e.dataTransfer.files[0];
    if (droppedFile) {
      processFile(droppedFile);
    }
  };

  const handleRowSelect = (index) => {
    setSelectedRow(index);
  };

  const handleContinue = () => {
    if (step === "mapping") {
      setStep("preview");
    } else if (step === "preview") {
      handleImport();
    }
  };

  const handleImport = async () => {
    setIsLoading(true);
    try {
      // Convert data to array of objects with required fields
      const attendeesData = previewData.map((row) => {
        const attendee = {};
        headers.forEach((header, index) => {
          const normalizedHeader = header.toLowerCase().trim();
          attendee[normalizedHeader] = row[index] || "";
        });
        return attendee;
      });

      // Prepare payload for API
      const payload = {
        attendees: attendeesData,
      };

      // Call API
      const response = await UserImport(payload);

      setIsLoading(false);

      if (response.success) {
        // Call parent callback with success
        onImportComplete && onImportComplete(attendeesData);
        handleClose();
      } else {
        setError(response.message || "Import failed. Please try again.");
      }
    } catch (err) {
      console.error("Import error:", err);
      setError(
        err.response?.data?.message || "Import failed. Please try again.",
      );
      setIsLoading(false);
    }
  };

  const handleBack = () => {
    if (step === "mapping") {
      setStep("upload");
    } else if (step === "preview") {
      setStep("mapping");
    }
  };


const handleDownloadTemplate = async () => {
  console.log("invoking the function");
  
  const sampleData = [
   
  ['John', 'Doe', 'john.doe@example.com', 'AMASI Member', 'Razorpay'],
  ['Jane', 'Smith', 'jane.smith@example.com', 'Non AMASI Member', 'cheque'],
  ['Robert', 'Johnson', 'robert.j@example.com', 'PGs, NBE, Fellow, M.Ch', 'Offline'],
  ['Sarah', 'Williams', 'sarah.w@example.com', 'FMAS Convocation Delegates', 'Razorpay'],
  ['Michael', 'Brown', 'michael.b@example.com', 'Gynaecologist', 'cheque'],
  ['Emily', 'Davis', 'emily.d@example.com', 'AMASI Member', 'Offline'],
  ['David', 'Miller', 'david.m@example.com', 'Non AMASI Member', 'Razorpay'],
  ['Lisa', 'Wilson', 'lisa.w@example.com', 'PGs, NBE, Fellow, M.Ch', 'cheque'],
  ['James', 'Moore', 'james.m@example.com', 'FMAS Convocation Delegates', 'Offline'],
  ['Patricia', 'Taylor', 'patricia.t@example.com', 'Gynaecologist', 'Razorpay'],
  ['Christopher', 'Anderson', 'chris.anderson@example.com', 'AMASI Member', 'cheque'],
  ['Jennifer', 'Thomas', 'jennifer.thomas@example.com', 'Non AMASI Member', 'Offline'],
  ['Daniel', 'Jackson', 'daniel.jackson@example.com', 'PGs, NBE, Fellow, M.Ch', 'Razorpay'],
  ['Nancy', 'White', 'nancy.white@example.com', 'FMAS Convocation Delegates', 'cheque'],
  ['Matthew', 'Harris', 'matthew.harris@example.com', 'Gynaecologist', 'Offline'],
  ['Karen', 'Martin', 'karen.martin@example.com', 'AMASI Member', 'Razorpay'],
  ['Anthony', 'Thompson', 'anthony.thompson@example.com', 'Non AMASI Member', 'cheque'],
  ['Betty', 'Garcia', 'betty.garcia@example.com', 'PGs, NBE, Fellow, M.Ch', 'Offline'],
  ['Mark', 'Martinez', 'mark.martinez@example.com', 'FMAS Convocation Delegates', 'Razorpay'],
  ['Helen', 'Robinson', 'helen.robinson@example.com', 'Gynaecologist', 'cheque']
  ];

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet('Attendees');

  // Set column widths
  worksheet.columns = [
    { header: 'first_name', key: 'first_name', width: 15 },
    { header: 'last_name', key: 'last_name', width: 15 },
    { header: 'email', key: 'email', width: 30 },
    { header: 'ticket_name', key: 'ticket_name', width: 30 },
    { header: 'payment_method', key: 'payment_method', width: 38 },
  ];

  // Style header row with rich text (white text + red asterisks)
  const headerRow = worksheet.getRow(1);
  const headerFields = [
    'first_name',
    'last_name',
    'email',
    'ticket_name',
    'payment_method'
  ];
  
  headerFields.forEach((field, index) => {
    const cell = headerRow.getCell(index + 1);
    
    // Use rich text to display field name in white and asterisk in red
    cell.value = {
      richText: [
        { font: { bold: true, color: { argb: 'FFFFFFFF' } }, text: field },
        { font: { bold: true, color: { argb: 'FFFF0000' } }, text: ' *' }
      ]
    };
    
    cell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FF184778' }
    };
    
    cell.alignment = { horizontal: 'center', vertical: 'center', wrapText: true };
  });

  // Add sample data rows
  sampleData.forEach((row) => {
    worksheet.addRow(row);
  });

  // Add data validation for payment_method column (Column E)
  worksheet.dataValidations.add('E2:E1000', {
    type: 'list',
    allowBlank: false,
    formulae: ['"Razorpay,cheque,Offline"'],
    showDropDown: true,
    prompt: 'Select: Razorpay, cheque, or Offline',
    promptTitle: 'Payment Method',
    error: 'Please select a valid payment method',
    errorTitle: 'Invalid Entry'
  });

  // Generate and download file
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { 
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = 'attendees_import_template.xlsx';
  link.click();
  URL.revokeObjectURL(url);
};

  const handlePasteData = () => {
    const pastedText = prompt(
      "Paste your table data here (tab or comma separated):",
    );
    if (!pastedText) return;

    setIsLoading(true);
    setTimeout(() => {
      try {
        const rows = pastedText.trim().split("\n");
        const parsedData = rows.map((row) => {
          // Handle both tab and comma separated values
          return row.split(/\t|,/).map((cell) => cell.trim());
        });

        if (parsedData.length === 0) {
          setError("No data found in pasted content");
          setIsLoading(false);
          return;
        }

        const parsedHeaders = parsedData[0];
        const dataRows = parsedData.slice(1);

        // Validate required fields
        const missingFields = requiredFields.filter(
          (field) =>
            !parsedHeaders.some(
              (header) => header.toLowerCase().trim() === field.toLowerCase(),
            ),
        );

        if (missingFields.length > 0) {
          setError(
            `Missing required columns: ${missingFields.join(", ")}. Please ensure your data has: ${requiredFields.join(", ")}`,
          );
          setIsLoading(false);
          return;
        }

        setHeaders(parsedHeaders);
        setPreviewData(dataRows);
        setIsLoading(false);
        setStep("mapping");
      } catch (err) {
        console.error("Error parsing pasted data:", err);
        setError("Error parsing pasted data. Please check the format.");
        setIsLoading(false);
      }
    }, 500);
  };

  const triggerFileInput = () => {
    fileInputRef.current.click();
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      size="lg"
      centered
      className="import-attendees-modal"
    >
<Modal.Header className="border-bottom bg-light d-flex align-items-center justify-content-between">
  <Modal.Title className="d-flex align-items-center">
    <PiMicrosoftExcelLogoFill className="text-success me-2" />
    <span>Import Attendees</span>
  </Modal.Title>

  <FaWindowClose
    style={{ cursor: "pointer", fontSize: "18px",color:"red" }}
    onClick={handleClose}
  />
</Modal.Header>

      <Modal.Body className="p-0">
        {error && (
          <Alert
            variant="danger"
            className="m-3 mb-0"
            onClose={() => setError("")}
            dismissible
          >
            {error}
          </Alert>
        )}

        <div className="p-4">
          {/* Progress Steps */}
          <div className="d-flex justify-content-center">
            <div
              className="position-relative d-flex align-items-center justify-content-center"
              style={{ width: "80%" }}
            >
              <div className="border_steper position-absolute w-100"></div>
              <div
                className="d-flex justify-content-between w-100 position-relative"
                style={{ zIndex: 2 }}
              >
                <div className="d-flex flex-column align-items-center">
                  <div
                    className={`rounded-circle d-flex align-items-center justify-content-center mb-2 ${
                      step === "upload"
                        ? "bg-primary text-white"
                        : "bg-light border"
                    }`}
                    style={{ width: "40px", height: "40px" }}
                  >
                    {step === "upload" ? (
                      "1"
                    ) : (
                      <FaCheck className="text-success" />
                    )}
                  </div>
                  <span
                    className={`small ${step === "upload" ? "text-primary font-weight-bold" : ""}`}
                  >
                    Upload
                  </span>
                </div>
                <div className="d-flex flex-column align-items-center">
                  <div
                    className={`rounded-circle d-flex align-items-center justify-content-center mb-2 ${
                      step === "mapping"
                        ? "bg-primary text-white"
                        : step === "preview"
                          ? "bg-light border"
                          : "bg-light border"
                    }`}
                    style={{ width: "40px", height: "40px" }}
                  >
                    {step === "upload" ? (
                      "2"
                    ) : step === "mapping" ? (
                      "2"
                    ) : (
                      <FaCheck className="text-success" />
                    )}
                  </div>
                  <span
                    className={`small ${step === "mapping" ? "text-primary font-weight-bold" : ""}`}
                  >
                    Map Data
                  </span>
                </div>
                <div className="d-flex flex-column align-items-center">
                  <div
                    className={`rounded-circle d-flex align-items-center justify-content-center mb-2 ${
                      step === "preview"
                        ? "bg-primary text-white"
                        : "bg-light border"
                    }`}
                    style={{ width: "40px", height: "40px" }}
                  >
                    3
                  </div>
                  <span
                    className={`small ${step === "preview" ? "text-primary font-weight-bold" : ""}`}
                  >
                    Preview
                  </span>
                </div>
              </div>
            </div>
          </div>

          {isLoading && (
            <div className="text-center py-5">
              <div className="spinner-border text-primary" role="status">
                <span className="sr-only">Loading...</span>
              </div>
              <p className="mt-3">Processing your file...</p>
            </div>
          )}

          {!isLoading && step === "upload" && (
            <div className="text-center py-4 import_model_div">
              <h4 className="mb-4">Import attendees in one go!</h4>
              <div
                className={`border rounded-lg p-5 mb-4 ${isDragging ? "bg-light border-primary" : ""}`}
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
                onDrop={handleDrop}
                style={{
                  borderStyle: "dashed",
                  borderWidth: "2px",
                  cursor: "pointer",
                  transition: "all 0.2s ease-in-out",
                }}
                onClick={triggerFileInput}
              >
              <div className="d-flex flex-column align-items-center">
  <div className="bg-light p-4 rounded-circle mb-3">
    <FaCloudUploadAlt className="text-primary" size={40} />
  </div>
  <h5 className="mb-2">Drop files here or click to upload</h5>
  <p className="text-muted mb-0">
    CSV, XLSX or XLS files accepted
  </p>
  <p className="text-muted small mt-2">
    Required columns: {requiredFields.map((field, index) => (
      <span key={field}>
        {field}
        <span style={{ color: 'red' }}> *</span>
        {index < requiredFields.length - 1 ? ', ' : ''}
      </span>
    ))}
  </p>
  <input
    type="file"
    ref={fileInputRef}
    className="d-none"
    accept=".csv,.xlsx,.xls"
    onChange={handleFileChange}
  />
</div>
              </div>

              <div className="d-flex flex-column align-items-center mt-4">
             
                       <button onClick={handleDownloadTemplate}   style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "8px",
            padding: "10px 16px",
            background: "#184778",
            color: "#ffffff",
            textDecoration: "none",
            borderRadius: "6px",
            fontSize: "14px",
            fontWeight: "500",
          }}>
                       <FaDownload style={{ fontSize: "12px" }} />  Download Sample Template
                       </button> 

                {/* <div className="text-center mt-2">
                  <button className="btn btn-info copy_pste_button_div" onClick={handlePasteData}>
                    <i className="fa fa-table"></i>
                    <span>Or click here to copy paste table data</span>
                  </button>
                </div> */}
              </div>
            </div>
          )}

          {!isLoading && step === "mapping" && (
            <div>
              <div className="select_heder_div_count">
                <h5 className="mb-0">Select Header Row</h5>
                {fileName && (
                  <Badge
                    bg="light"
                    text="dark"
                    className="d-flex align-items-center p-2"
                  >
                    <FaFileExcel className="text-success me-2" />
                    <span>{fileName}</span>
                  </Badge>
                )}
              </div>

              <Alert className="alret_importr_div">
                <FaTable />
                <span>
                  Verify that the first row contains your column headers
                </span>
              </Alert>

              <div className="table-responsive border rounded import_tble_div">
                <Table className="table-hover mb-0">
                  <thead className="bg-light">
                    <tr>
                      <th style={{ width: "60px" }} className="text-center">
                        Header Row
                      </th>
                      {headers.map((header, index) => (
                        <th key={index} className="px-3">
                          {header}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {previewData.slice(0, 5).map((row, rowIndex) => (
                      <tr
                        key={rowIndex}
                        className={rowIndex === 0 ? "table-primary" : ""}
                      >
                        <td className="text-center">
                          <div className="form-check d-flex justify-content-center">
                            <FormCheck
                              type="checkbox"
                              checked={rowIndex === 0}
                              readOnly
                              id={`checkbox-${rowIndex}`}
                              label=" "
                            />
                          </div>
                        </td>
                        {row.map((cell, cellIndex) => (
                          <td key={cellIndex} className="px-3">
                            {cell}
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>

              {previewData.length > 5 && (
                <div className="text-center text-muted mt-2">
                  <small>Showing 5 of {previewData.length} rows</small>
                </div>
              )}
            </div>
          )}

          {!isLoading && step === "preview" && (
            <div>
              <div className="select_heder_div_count">
                <h5 className="mb-0">Preview Data</h5>
                <Badge bg="success" className="d-flex align-items-center p-2">
                  <span>{previewData.length} records found</span>
                </Badge>
              </div>

              <Alert variant="info" className="alret_importr_div alert">
                <i className="fa fa-check"></i>
                <span>Review your data before importing</span>
              </Alert>

              <div className="table-responsive border rounded preview_table_div">
                <Table className="mb-0">
                  <thead className="bg-light">
                    <tr>
                      {headers.map((header, index) => (
                        <th key={index} className="px-3">
                          {header}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {previewData.slice(0, 5).map((row, rowIndex) => (
                      <tr key={rowIndex}>
                        {row.map((cell, cellIndex) => (
                          <td key={cellIndex} className="px-3">
                            {cell}
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>

              {previewData.length > 5 && (
                <div className="text-center text-muted mt-2">
                  <small>Showing 5 of {previewData.length} rows</small>
                </div>
              )}
            </div>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer className="border-top bg-light">
        {step !== "upload" && (
          <Button
            variant="outline-secondary"
            onClick={handleBack}
            disabled={isLoading}
          >
            Back
          </Button>
        )}
        {step !== "upload" && (
          <Button
            variant="primary"
            onClick={handleContinue}
            disabled={isLoading}
            className="d-flex align-items-center"
          >
            {isLoading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                <span>Importing...</span>
              </>
            ) : (
              <span>{step === "preview" ? "Import Data" : "Continue"}</span>
            )}
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default ImportModal;
